import { ca } from "date-fns/locale";

export interface AppDictionary {
    [key: string]: (user_name: string) => { us: string|any[]; es: string|any[] };
}

export const appDictionary: AppDictionary = {
    welcome: (user_name: string) => ({
        es: `¡Hola ${user_name}!`,
        us: `Hello ${user_name}!`
    }),
    sign_out: () => ({
        es: `Cerrar sesión`,
        us: `Sign out`
    }),
    home: () => ({
        es: `Inicio`,
        us: `Home`
    }),
    administration: () => ({
        es: `Administración`,
        us: `Administration`
    }),
    sales_perfformance_analysis: () => ({
        es: `Análisis de ventas`,
        us: `Sales performance analysis`
    }),
    customers_segmentation: () => ({
        es: `Segmentación de clientes`,
        us: `Customers segmentation`
    }),
    sales_agents_segmentation: () => ({
        es: `Segmentación de agentes`,
        us: `Sales agents segmentation`
    }),
    customer_analysis: () => ({
        es: `Análisis de clientes`,
        us: `Customer analysis`
    }),
    sales_agents_analysis: () => ({
        es: `Análisis de agentes`,
        us: `Sales agents analysis`
    }),
    sales_goals: () => ({
        es: `Objetivos de ventas`,
        us: `Sales goals`
    })
};